// extracted by mini-css-extract-plugin
export default {"wrapper":"form_wrapper__hCS12","info":"form_info__Ynxbw","label":"form_label__Ko-dZ","formWrapper":"form_formWrapper__CvSl8","opacity-transition":"form_opacity-transition__ewXtk"};